export default __webpack_public_path__ + "static/media/gordita-bold.c16b9557.woff";